import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './BootstrapSectra/sectra-styling.css';

import './Ids7App';
import './index.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { getReduxStoreForProvider } from './Components/ReduxStateStore';
import { Root } from './Root';

export const loadWebApp = () => {
  if (process.env.NODE_ENV === 'production') {
    document.querySelector('style')?.remove();
  }

  ReactDOM.render(
        <Router>
            <Provider store={getReduxStoreForProvider()}>
                <Root />
            </Provider>
        </Router>, document.getElementById('app-container'));
};

window._loadWebApp_ = loadWebApp;
